import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  SettingOutlined,
  HomeFilled,
  ControlFilled,
  VideoCameraFilled,
  PlusCircleFilled,
  PlaySquareFilled,
  CalendarFilled,
} from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { decryptData } from '../../../utils/encryptData';
import { FaBook, FaUser } from 'react-icons/fa';
import { BsFillPeopleFill } from 'react-icons/bs';
import { FaHashtag } from 'react-icons/fa';
import { MdArticle } from 'react-icons/md';
import { CgMediaLive } from 'react-icons/cg';
import { SlFeed } from 'react-icons/sl';
import { RiStockFill } from 'react-icons/ri';

function MobileSideBar({ onClick }) {
  const [openAdmin, setOpenAdmin] = useState(false); // State to toggle the admin dashboard
  const [openSessions, setOpenSessions] = useState(false); // State for session dropdown
  const [openCollections, setOpenCollections] = useState(false); // State for collections dropdown
  const [openCommunity, setOpenCommunity] = useState(false); // State for collections dropdown
  const [openMarket, setOpenMarket] = useState(false); // State for collections dropdown

  const toggleAdmin = () => {
    setOpenAdmin(!openAdmin);
  };

  const toggleCommunity = () => {
    setOpenCommunity(!openCommunity);
  };

  const toggleMarket = () => {
    setOpenMarket(!openMarket);
  };

  const toggleSessions = () => {
    setOpenSessions(!openSessions);
  };

  const toggleCollections = () => {
    setOpenCollections(!openCollections);
  };

  const { isAuthenticated, rl } = useSelector((state) => state.auth); // get role and isAuthenticated from redux state
  const decryptRole = decryptData(rl); // decrypt role

  return (
    <div>
      <aside
        className="fixed top-[68px] left-0 z-40 w-64 h-screen transition-transform -translate-x-full translate-x-0 transform-gpu delay-150"
        aria-label="Sidebar"
      >
        <div className="h-full px-3 py-4 overflow-y-auto bg-background-primary-color">
          <ul className="space-y-2 font-medium ">
            {/* Home */}
            <li>
              <Link
                to="/"
                onClick={onClick}
                className="flex items-center p-2 text-gray-900 rounded-lg text-white hover:text-black hover:bg-btn-hover-color group"
              >
                <HomeFilled />
                <span className="ms-3">Home</span>
              </Link>
            </li>
            {/* Sessions */}
            <li>
              <Link
                to="/session/all"
                onClick={onClick}
                className="flex items-center p-2 text-gray-900 rounded-lg  hover:text-black text-white hover:bg-btn-hover-color group"
              >
                <VideoCameraFilled />
                <span className="ms-3">Sessions</span>
              </Link>
            </li>
            {/* Event Calendar */}
            <li>
              <Link
                to="/event/calendar"
                onClick={onClick}
                className="flex items-center p-2 text-gray-900 rounded-lg hover:text-black text-white hover:bg-btn-hover-color group"
              >
                <CalendarFilled />
                <span className="ms-3">Event Calendar</span>
              </Link>
            </li>
            {/* Education Material */}
            <li>
              <Link
                to="/education/meterial"
                onClick={onClick}
                className="flex items-center p-2 text-gray-900 rounded-lg hover:text-black text-white hover:bg-btn-hover-color group"
              >
                <FaBook />
                <span className="ms-3">Education Material</span>
              </Link>
            </li>

            {/* market-analysis*/}

            <li>
              <button
                onClick={toggleMarket}
                type="button"
                className="flex items-center w-full p-2 text-base hover:text-gray-900 transition duration-75 rounded-lg group hover:bg-btn-hover-color text-white dark:hover:bg-btn-hover-color"
                aria-controls="admin-dropdown"
                data-collapse-toggle="admin-dropdown"
              >
                <BsFillPeopleFill />
                <span className="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap hover:text-black">
                  Market Analysis
                </span>
                <svg
                  className="w-3 h-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 10 6"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeWidth="round"
                    d="m1 1 4 4 4-4"
                  />
                </svg>
              </button>

              <ul id="market-dropdown" className="py-2 space-y-2 ml-5">
                {openMarket && (
                  <>
                    {/* feed */}
                    <li>
                      <Link
                        to="/analysis/market-analysis"
                        onClick={onClick}
                        className="flex items-center p-2  hover:text-black rounded-lg text-white hover:bg-btn-hover-color group"
                      >
                        <BsFillPeopleFill />
                        <span className="ms-3">Market Analysis</span>
                      </Link>
                    </li>

                    {/* feed */}
                    <li>
                      <Link
                        to="/analysis/trading-signal"
                        onClick={onClick}
                        className="flex items-center p-2  hover:text-black rounded-lg text-white hover:bg-btn-hover-color group"
                      >
                        <RiStockFill />
                        <span className="ms-3">Trading Signals</span>
                      </Link>
                    </li>
                  </>
                )}
              </ul>
            </li>

            {/* Community */}
            <li>
              <button
                onClick={toggleCommunity}
                type="button"
                className="flex items-center w-full p-2 text-base hover:text-gray-900 transition duration-75 rounded-lg group hover:bg-btn-hover-color text-white dark:hover:bg-btn-hover-color"
                aria-controls="admin-dropdown"
                data-collapse-toggle="admin-dropdown"
              >
                <BsFillPeopleFill />
                <span className="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap hover:text-black">
                  Community
                </span>
                <svg
                  className="w-3 h-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 10 6"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeWidth="round"
                    d="m1 1 4 4 4-4"
                  />
                </svg>
              </button>

              <ul id="community-dropdown" className="py-2 space-y-2 ml-5">
                {openCommunity && (
                  <>
                    {/* feed */}
                    <li>
                      <Link
                        to="/community/feed"
                        onClick={onClick}
                        className="flex items-center p-2 text-gray-900 hover:text-black rounded-lg text-white hover:bg-btn-hover-color group"
                      >
                        <SlFeed />
                        <span className="ms-3">Feed</span>
                      </Link>
                    </li>

                    {/* feed */}
                    <li>
                      <Link
                        to="/community/topics"
                        onClick={onClick}
                        className="flex items-center p-2 text-gray-900 hover:text-black rounded-lg text-white hover:bg-btn-hover-color group"
                      >
                        <FaHashtag />
                        <span className="ms-3">Topic</span>
                      </Link>
                    </li>

                    {/* feed */}
                    <li>
                      <Link
                        to="/community/articles"
                        onClick={onClick}
                        className="flex items-center p-2 text-gray-900 hover:text-black rounded-lg text-white hover:bg-btn-hover-color group"
                      >
                        <MdArticle />
                        <span className="ms-3">Articles</span>
                      </Link>
                    </li>

                    {/* feed */}
                    <li>
                      <Link
                        to="/community/live"
                        onClick={onClick}
                        className="flex items-center p-2 text-gray-900 rounded-lg hover:text-black text-white hover:bg-btn-hover-color group"
                      >
                        <CgMediaLive />
                        <span className="ms-3">Live</span>
                      </Link>
                    </li>
                  </>
                )}
              </ul>
            </li>

            {/* Admin Dashboard */}
            {isAuthenticated &&
              (decryptRole === 'admin' || decryptRole === 'editor') && (
                <li>
                  <button
                    onClick={toggleAdmin}
                    type="button"
                    className="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:bg-btn-hover-color text-white dark:hover:bg-btn-hover-color"
                    aria-controls="admin-dropdown"
                    data-collapse-toggle="admin-dropdown"
                  >
                    <ControlFilled />
                    <span className="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap hover:text-black">
                      Admin Dashboard
                    </span>
                    <svg
                      className="w-3 h-3"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 10 6"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeWidth="round"
                        d="m1 1 4 4 4-4"
                      />
                    </svg>
                  </button>

                  {openAdmin && (
                    <ul id="admin-dropdown" className="py-2 space-y-2 ml-5">
                      {decryptRole === 'admin' && (
                        <>
                          <li>
                            <Link
                              to="admin/users/all"
                              onClick={onClick}
                              className="flex items-center p-2 text-gray-900 hover:text-black rounded-lg text-white hover:bg-btn-hover-color group"
                            >
                              <FaUser />
                              <span className="ms-3">Users</span>
                            </Link>
                          </li>
                          <li>
                            <button
                              onClick={toggleSessions}
                              type="button"
                              className="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:bg-btn-hover-color text-white dark:hover:bg-btn-hover-color"
                              aria-controls="sessions-dropdown"
                              data-collapse-toggle="sessions-dropdown"
                            >
                              <VideoCameraFilled />
                              <span className="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap hover:text-black">
                                Sessions
                              </span>
                              <svg
                                className="w-3 h-3"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 10 6"
                              >
                                <path
                                  stroke="currentColor"
                                  strokeLinecap="round"
                                  strokeWidth="round"
                                  d="m1 1 4 4 4-4"
                                />
                              </svg>
                            </button>
                            {openSessions && (
                              <ul
                                id="sessions-dropdown"
                                className="py-2 space-y-2 ml-5"
                              >
                                <li>
                                  <Link
                                    to="admin/session/all"
                                    onClick={onClick}
                                    className="flex items-center hover:text-black p-2 text-gray-900 rounded-lg text-white hover:bg-btn-hover-color group"
                                  >
                                    <PlaySquareFilled />
                                    <span className="ms-3">All Sessions</span>
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to="admin/session/add"
                                    onClick={onClick}
                                    className="flex items-center hover:text-black p-2 text-gray-900 rounded-lg text-white hover:bg-btn-hover-color group"
                                  >
                                    <PlusCircleFilled />
                                    <span className="ms-3">Add Session</span>
                                  </Link>
                                </li>
                              </ul>
                            )}
                          </li>
                          <li>
                            <button
                              onClick={toggleCollections}
                              type="button"
                              className="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:bg-btn-hover-color text-white dark:hover:bg-btn-hover-color"
                              aria-controls="collections-dropdown"
                              data-collapse-toggle="collections-dropdown"
                            >
                              <BsFillPeopleFill />
                              <span className="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap hover:text-black">
                                Collections
                              </span>
                              <svg
                                className="w-3 h-3"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 10 6"
                              >
                                <path
                                  stroke="currentColor"
                                  strokeLinecap="round"
                                  strokeWidth="round"
                                  d="m1 1 4 4 4-4"
                                />
                              </svg>
                            </button>
                            {openCollections && (
                              <ul
                                id="collections-dropdown"
                                className="py-2 space-y-2 ml-5"
                              >
                                <li>
                                  <Link
                                    to="admin/collection/all"
                                    onClick={onClick}
                                    className="flex items-center  hover:text-black p-2 text-gray-900 rounded-lg text-white hover:bg-btn-hover-color group"
                                  >
                                    <PlaySquareFilled />
                                    <span className="ms-3">
                                      All Collections
                                    </span>
                                  </Link>
                                </li>
                              </ul>
                            )}
                          </li>
                        </>
                      )}
                    </ul>
                  )}
                </li>
              )}
          </ul>
        </div>
      </aside>
    </div>
  );
}

export default MobileSideBar;
